import React from "react";
import styled from "styled-components";
import { isColor } from "@cortexglobal/cortex-utilities";

import { Panel, Image, IconTextButton } from "../../index";
import Badge from "../badge";

export const SearchResultWrapper = styled(Panel)`
    box-shadow: ${({ boxShadow, theme }) =>
        boxShadow || theme.search.boxShadow};
    background-color: ${({ background, theme }) =>
        isColor(background) ? background : theme.search.background};
    transition: all 200ms;
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    transition: all 200ms ease-out;
    aside {
        color: ${({ theme }) => theme.search.summary.color};
    }
    button,
    aside {
        transition: color 200ms;
    }
    &:hover {
        box-shadow: ${({ boxShadow, theme }) =>
            boxShadow || theme.search.boxShadowHover};
        transform: ${({ theme }) => theme.search.transformHover};
        /* aside, */
        h5 {
            color: ${({ theme }) => theme.search.hoverColor};
            text-decoration: ${({ theme }) => theme.search.hoverTextDecoration};
        }
    }
`;
export const SearchResultImageWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 100%;
    max-width: 100%;
    height: ${({ theme }) => theme.search.image.height};
    background: ${({ background, theme }) =>
        background || theme.search.image.background};
    overflow: hidden;
`;

export const SearchResultImage = styled(Image)`
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    display: inline-block;
    /* width: 95%;
    height: 90%; */
    padding: ${({ theme }) => theme.search.image.padding};
    object-fit: ${({ objectFit, theme }) =>
        objectFit || theme.search.image.objectFit};

    position: relative;
`;

export const SearchResultButton = styled(IconTextButton)`
    width: 100%;
    height: 100%;
    padding: 0.4rem 0.8rem;
    position: relative;
    display: ${({ icon }) =>
        icon !== null && icon !== undefined ? "flex" : "block"};
`;
export const SearchResultTitle = styled.h5`
    /* display: flex; */
    /* padding: 0 0 0 0.2rem; */
    margin: 0;
    font-size: 1rem;
    line-height: 1.4rem;
    text-align: left;
    width: ${({ width }) => (width ? width : "95%")};
    color: ${({ theme }) => theme.search.title.color};
    /* align-items: flex-start; */
    /* height: 100%; */
    /* text-overflow: ellipsis;
    overflow: hidden;
    white-space: normal; */
    max-height: 3rem;
`;

export const SearchResultSummary = styled.aside`
    margin-top: 0.5rem;
    font-size: 0.8rem;
    font-weight: normal;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: noWrap;
    width: ${({ width }) => (width ? width : "90%")};
    text-decoration: none;
    &:hover {
        text-decoration: none !important;
    }
    /* color: #403e37 !important; */
`;

export const SearchResultBadge = styled(Badge)`
    display: ${({ showBadge, theme, badgeType }) =>
        showBadge
            ? "block"
            : theme.search.badge.badgeType[badgeType] &&
              theme.search.badge.badgeType[badgeType].display
            ? theme.search.badge.badgeType[badgeType].display
            : theme.search.badge.show
            ? "block"
            : "none"};
    position: absolute;
    top: 0;
    right: 0;
    text-transform: ${({ theme }) => theme.search.badge.textTransform};
    color: ${({ theme, badgeType }) =>
        theme.search.badge.badgeType[badgeType] &&
        theme.search.badge.badgeType[badgeType].color
            ? theme.search.badge.badgeType[badgeType].color
            : theme.search.badge.badgeType["default"].color};
    background: ${({ theme, badgeType }) =>
        theme.search.badge.badgeType[badgeType] &&
        theme.search.badge.badgeType[badgeType].background
            ? theme.search.badge.badgeType[badgeType].background
            : theme.search.badge.badgeType["default"].background};
`;
